import React from 'react';

// Shared formatting for the PLAY games admin pages (PlayGames, PlayGame).

// Every timestamp on a PlayGame is UTC (StartsAt/EndsAt too — they are the
// activity's StartsAt.UtcDateTime). The API serializes them without a zone suffix; without the 'Z' the
// browser would read them as local time and shift every timestamp.
export const utc = (value) => {
  if (!value) return null;
  const s = String(value);
  return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : `${s}Z`);
};

export const fmtUtc = (value) => {
  const d = utc(value);
  return d ? d.toLocaleString() : '—';
};

// Compact form for dense tables: "30 Sept, 14:05" (year only when not this year).
export const fmtShort = (value) => {
  const d = utc(value);
  if (!d) return '—';
  const opts = { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' };
  if (d.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
  return d.toLocaleString(undefined, opts);
};

export const fmtMoney = (minor, currency) =>
  minor == null ? '—' : `${(minor / 100).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${currency || ''}`.trim();

const STATUS_COLORS = {
  Draft: ['#eee', '#666'],
  Open: ['#fff4d6', '#8a6100'],
  Confirmed: ['#dff5e3', '#1e6b2f'],
  Played: ['#dde8f7', '#1a3559'],
  Expired: ['#f3e3e3', '#8a2b2b'],
  Cancelled: ['#f0f0f0', '#888'],
  // Sides and invites
  Paid: ['#dff5e3', '#1e6b2f'],
  Pending: ['#eee', '#666'],
  Sent: ['#dde8f7', '#1a3559'],
  Viewed: ['#fff4d6', '#8a6100'],
  Accepted: ['#dff5e3', '#1e6b2f'],
  Skipped: ['#f3e3e3', '#8a2b2b'],
  Completed: ['#dff5e3', '#1e6b2f'],
  Settled: ['#dff5e3', '#1e6b2f'],
  Failed: ['#f3e3e3', '#8a2b2b'],
};

export const StatusBadge = ({ status }) => {
  const [bg, fg] = STATUS_COLORS[status] || ['#eee', '#444'];
  return (
    <span style={{ background: bg, color: fg, fontSize: 12, fontWeight: 600, borderRadius: 999, padding: '2px 8px', whiteSpace: 'nowrap' }}>
      {status}
    </span>
  );
};

export const tableWrap = { background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8, overflowX: 'auto' };
export const table = { width: '100%', borderCollapse: 'collapse', fontSize: 14 };
export const headRow = { borderBottom: '2px solid #ddd', textAlign: 'left', background: '#f5f5f5' };
export const bodyRow = { borderBottom: '1px solid #eee' };
export const cell = { padding: 10, verticalAlign: 'top' };
export const muted = { fontSize: 12, color: '#888' };
